"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ghost = _interopRequireDefault(require("./images/ghost.svg"));

var _github = _interopRequireDefault(require("./images/github.svg"));

var _linkedin = _interopRequireDefault(require("./images/linkedin.svg"));

var _questionCircle = _interopRequireDefault(require("./images/question-circle.svg"));

var _telegram = _interopRequireDefault(require("./images/telegram.svg"));

var _twitter = _interopRequireDefault(require("./images/twitter.svg"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Footer = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(Footer, _react$default$Compon);

  var _super = _createSuper(Footer);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _super.call(this, props);
    _this.state = {
      matches: window.matchMedia("(min-width: 768px)").matches
    };
    return _this;
  }

  _createClass(Footer, [{
    key: "setMatches",
    value: function setMatches(matches) {
      this.setState({
        matches: matches
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var handler = function handler(e) {
        return _this2.setMatches(e.matches);
      };

      window.matchMedia("(min-width: 768px)").addListener(handler);
    }
  }, {
    key: "render",
    value: function render() {
      var matches = this.state.matches;
      var name = this.props.name;
      return _react.default.createElement("footer", {
        style: {
          fontFamily: "Roboto,sans-serif",
          fontSize: "1rem",
          bottom: "0",
          left: "0",
          width: "100%",
          height: "4rem",
          display: "grid",
          grid: matches ? "1fr / [footer-start] 20px [banner] 10fr [title] 10fr [help] 4fr 1fr [social] 5fr 20px [footer-end]" : "1fr / [footer-start] 30px [banner] 9fr [help] 6fr 30px [footer-end]",
          background: "#4d00b4",
          color: "white",
          alignItems: "center",
          justifyItems: "center",
          minHeight: "40px"
        }
      }, _react.default.createElement("div", {
        style: {
          gridColumn: "banner",
          justifySelf: "start"
        }
      }, _react.default.createElement("a", {
        style: {
          color: "white",
          textDecoration: "none",
          fontFamily: "Roboto,sans-serif",
          fontSize: "1rem"
        },
        href: "https://kleros.io"
      }, "Find out more about Kleros")), _react.default.createElement("div", {
        style: {
          display: matches ? "" : "none",
          gridColumn: "title",
          fontFamily: "Roboto,sans-serif",
          fontSize: "1rem"
        }
      }, name), _react.default.createElement("div", {
        style: {
          display: "grid",
          gridColumn: "help",
          justifySelf: "end"
        }
      }, _react.default.createElement("a", {
        href: "https://t.me/kleros",
        style: {
          color: "white",
          textDecoration: "none"
        }
      }, "I need help", " ", _react.default.createElement("img", {
        src: _questionCircle.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "Question"
      }))), _react.default.createElement("div", {
        style: {
          display: matches ? "" : "none",
          gridColumn: "social",
          justifySelf: "stretch",
          alignItems: "center",
          textAlign: "center"
        }
      }, _react.default.createElement("div", {
        style: {
          display: matches ? "grid" : "none",
          alignItems: "center",
          grid: " 1fr / 1fr"
        }
      }, _react.default.createElement("div", {
        className: "icons",
        style: {
          display: matches ? "grid" : "none",
          grid: "1fr / 1fr 1fr 1fr 1fr 1fr"
        }
      }, _react.default.createElement("a", {
        href: "https://twitter.com/kleros_io?",
        rel: "noopener noreferrer",
        target: "_blank"
      }, _react.default.createElement("img", {
        src: _twitter.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "Twitter"
      })), _react.default.createElement("a", {
        href: "https://github.com/kleros",
        rel: "noopener noreferrer",
        target: "_blank"
      }, _react.default.createElement("img", {
        src: _github.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "Github"
      })), _react.default.createElement("a", {
        href: "https://blog.kleros.io/",
        rel: "noopener noreferrer",
        target: "_blank"
      }, _react.default.createElement("img", {
        src: _ghost.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "Ghost"
      })), _react.default.createElement("a", {
        href: "https://www.linkedin.com/company/kleros/",
        rel: "noopener noreferrer",
        target: "_blank"
      }, _react.default.createElement("img", {
        src: _linkedin.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "LinkedIn"
      })), _react.default.createElement("a", {
        href: "https://t.me/kleros",
        rel: "noopener noreferrer",
        target: "_blank"
      }, _react.default.createElement("img", {
        src: _telegram.default,
        style: {
          verticalAlign: "middle"
        },
        alt: "Telegram"
      }))))));
    }
  }]);

  return Footer;
}(_react.default.Component);

var _default = Footer;
exports.default = _default;